import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";
import { Expose } from "class-transformer";

export default class OrderItemsAttributesItem {
  @IsNumber()
  @Expose()
  dataType!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  attributePrototypeId: number | undefined | null;
  @IsString()
  @Expose()
  label!: string;
  @IsOptional()
  @IsString()
  @Expose()
  value!: string | null;
  @IsBoolean()
  @Expose()
  isPrintable!: boolean;
  @IsOptional()
  @IsBoolean()
  @Expose()
  isRequired: boolean | undefined;
  @IsNumber()
  @Expose()
  ordinal!: number;
}
